var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',{},[_c('v-img',{attrs:{"src":require('@/assets/bg_image.jpg'),"lazy-src":require('@/assets/bg_image_blur.jpg'),"height":this.$vuetify.breakpoint.height}},[_c('LoginForm')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }